(function () {
    "use strict";

    /*
     * options:
     *  chartType: string (one of "line", ...)
     *  chartOptions: function () run in context of control to return chart options.
     */
    var ChartControl = Solovis.defineClass(
        "Solovis.Reports.Parts.ChartControl",
        Solovis.Reports.Parts.PartControl,
        function (options) {
            var self = this;

            this.dataSets = null;
            this._chartType = options.settings.chartType;
            this._chartOptions = options.settings.chartOptions ? options.settings.chartOptions : null;
        });

    ChartControl.requiredModules = ["Solovis.Charts"];

    ChartControl.prototype.doInit = function () {        
    };

    ChartControl.prototype.doRender = function () {
        var self = this;
        
        if (!this.dataSets) {
            return;
        }

        if (!this._chartControlHost) {
            this._chartControlHost = new Solovis.UI.ControlHost({ container: this.container });
        }

        this._chartControl = null;
        
        if (this._chartOptions) {
            try {                
                var chartOptionsToUse = this._chartOptions.call(this);
                if (chartOptionsToUse) {
                    var chartType = null;
                    switch (this._chartType) {
                        case "discreteBar": chartType = (Solovis as any).Charts.DiscreteBarChartControl; break;
                        case "bar": chartType = (Solovis as any).Charts.BarChartControl; break;
                        case "cumulativeReturn": chartType = (Solovis as any).Charts.CumulativeReturnLineChartControl; break;
                        case "line": chartType = (Solovis as any).Charts.LineChartControl; break;

                        default:
                            throw "Unknown chart type: " + this._chartType;                            
                    }

                    this._chartControl = new chartType(chartOptionsToUse);
                    this._chartControlHost.setCurrentControl(this._chartControl);
                }
                else {
                    this._chartControlHost.setCurrentControl(null);
                }
            }
            catch (error) {
                console.log(error);

                if (typeof error == "string") {
                    self.container.append(error);
                }
                else if (error && error.message && typeof error.message == "string") {
                    self.container.append(error.message);
                }
                else {
                    self.container.append("Unknown error when rendering content of ChartControl.");
                }
            }
        }
        else {
            this._chartControlHost.setCurrentControl(null);
        }
    };

    ChartControl.prototype.doDestroy = function () {
        if (this._chartControlHost) {
            this._chartControlHost.setCurrentControl(null);
        }
    };

})();